import { render, staticRenderFns } from "./ObiSurveyQuestionAnswerCard.vue?vue&type=template&id=62f73a84&scoped=true&"
import script from "./ObiSurveyQuestionAnswerCard.vue?vue&type=script&lang=js&"
export * from "./ObiSurveyQuestionAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiSurveyQuestionAnswerCard.vue?vue&type=style&index=0&id=62f73a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f73a84",
  null
  
)

export default component.exports